// @flow
import React from 'react';
import L from 'react-loadable';

import CircularProgress from 'material-ui/CircularProgress';

export default (loader, options = { useSpinner: true }) =>
  L({
    loader,
    loading: () => (options.useSpinner ? <CircularProgress /> : null),
  });



// WEBPACK FOOTER //
// ./components/Loadable/index.js